import { Injectable } from '@angular/core';
import { PlayerApiClient } from './player-api/player-api-client.service';
import { ReaderApiClient } from './reader-api/reader-api.client.service';

@Injectable({ providedIn: 'root' })
export class CoreApiClient {
  constructor(
    private readonly playerApiClient: PlayerApiClient,
    private readonly readerApiClient: ReaderApiClient,
  ) {
  }

  getApiClient(): PlayerApiClient | ReaderApiClient {
    const useReaderApi = sessionStorage.getItem('useReaderApi');
    return (useReaderApi === 'true') ? this.readerApiClient : this.playerApiClient;
  }
}
